import React from 'react';
import { useQueryClient } from 'react-query';

import Pill from '@components/Pill';
import Spinner from '@components/Spinner';
import useEntitiesTop from '@hooks/useEntitiesTop';
import useFollowUpdate from '@hooks/useFollowUpdate';
import { FollowAction, FollowType } from '@utils/backend-api/follow';
import { capitalize } from '@utils/formatting';

import type { TrendingTopicPillsProps } from './interfaces';

const TrendingTopicPills = ({ identityId }: TrendingTopicPillsProps) => {
  const queryClient = useQueryClient();
  const { data: topEntityOptions, isLoading } = useEntitiesTop();
  const { mutateAsync: updateFollow } = useFollowUpdate();

  const trendingTopics = topEntityOptions?.filter((entity) => !entity?.following);

  const handleFollow = async (entityId: number) => {
    await updateFollow({
      followAction: FollowAction.Follow,
      followeeId: entityId,
      followType: FollowType.Entity,
      identityId,
      queryClient,
    });
  };

  if (isLoading) return <Spinner marginY="small" />;

  if (!trendingTopics?.length) return null;

  return (
    <div className="flex max-h-[110px] flex-wrap overflow-hidden">
      {trendingTopics.map((entity) => (
        <Pill
          key={entity.value}
          className="!border-grayscale-gray !py-[6px] !font-suisse-intl !text-grayscale-charcoal"
          onClick={() => handleFollow(entity.value)}
          text={capitalize(entity.label)}
        />
      ))}
    </div>
  );
};

export default TrendingTopicPills;
